export default "__VITE_ASSET__06377f11__"